import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PopoverPattern from '@mlb/react-patterns/components/Popover/popover.tsx';
import ButtonPattern from '@mlb/react-patterns/components/Button/button.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

import { useClipTrimming } from '../../hooks';
import PopoverButton from './PopoverButton';

const Popover = styled(PopoverPattern)`
    z-index: 3;
`;

const OptionsWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin-right: -10px;
`;

const PopoverContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 5px;
`;

const Button = styled(ButtonPattern)`
    ${IconWrapper} {
        padding-top: 0;
        stroke: none;
    }
`;

const PopoverMenu = (props) => {

    const {
        removeClip,
        reorder,
        mediaPlayback,
        index,
        numberOfCards,
        openClipTrimming,
    } = props;

    const {
        move_video_up: moveVideoUp = 'Move Video Up',
        move_video_down: moveVideoDown = 'Move Video Down',
        trim_video: trimVideo = 'Trim Video',
        remove_video: removeVideo = 'Remove Video',
    } = useDictionary();

    const { canTrim } = useClipTrimming(mediaPlayback);

    return (
        <OptionsWrapper>
            <Popover
                showMultiple={false}
                placement={'bottom'}
                popoverOffset={[
                    0,
                    4,
                ]}
                preventOverflowPadding={2}
                popoverContent={
                    <PopoverContent>
                        {index !== 0
                            && <PopoverButton
                                iconName={'move-up'}
                                label={moveVideoUp}
                                handlers={{
                                    onClick: () => {

                                        Tracking.trackMoveReelUpClick();
                                        reorder(index, index - 1);

                                    },
                                }}
                            />
                        }
                        {index !== numberOfCards - 1
                            && <PopoverButton
                                iconName={'move-down'}
                                label={moveVideoDown}
                                handlers={{
                                    onClick: () => {

                                        Tracking.trackMoveReelDownClick();
                                        reorder(index, index + 1);

                                    },
                                }}
                            />
                        }
                        {canTrim
                            && <PopoverButton
                                iconName={'scissors'}
                                label={trimVideo}
                                handlers={{
                                    onClick: () => {

                                        openClipTrimming(mediaPlayback.id);

                                    },
                                }}
                            />
                        }
                        <PopoverButton
                            iconName={'close'}
                            label={removeVideo}
                            handlers={{
                                onClick: () => {

                                    Tracking.trackRemoveReelClick();
                                    removeClip(mediaPlayback.id);

                                },
                            }}
                        />
                    </PopoverContent>
                }
            >
                <Button
                    iconName={'dot-menu'}
                    size={'md'}
                    styleName={'default'}
                    shape={'hollow-borderless'}
                    hasHover={false}
                />
            </Popover>
        </OptionsWrapper>
    );

};

PopoverMenu.propTypes = {
    removeClip: PropTypes.func.isRequired,
    reorder: PropTypes.func.isRequired,
    mediaPlayback: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    numberOfCards: PropTypes.number.isRequired,
    openClipTrimming: PropTypes.func.isRequired,
};

export default PopoverMenu;
